import { UIStyledSection } from '../components/UIStyledSection';
import { InputExamples } from '@app/modules/ui-kit/components/InputExamples';
import { ButtonExamples } from '@app/modules/ui-kit/components/ButtonExamples';

export const UISectionFeatured: React.FC = () => {
  return (
    <UIStyledSection title="Featured">
      <div className="grid grid-cols-5 gap-10">
        <div className="col-span-2">
          <InputExamples />
        </div>
        <div className="col-span-3">
          <ButtonExamples />
        </div>
      </div>
    </UIStyledSection>
  );
};
